var Actions;
(function (Actions) {
    Actions["GET_DIVISION_LIST"] = "getDivisionList";
    Actions["GET_DIVISION_LIST_ALLDATA"] = "getDivisionListAllData";
    Actions["UPDATE_DIVISION_PAGE_FILTER"] = "updateDivisionPageFilter";
    Actions["UPDATE_DIVISION_SIZE"] = "updateDivisionSize";
    Actions["UPDATE_DIVISION_CODE"] = "updateDivisionCode";
    Actions["UPDATE_DIVISION_DESC"] = "updateDivisionDesc";
})(Actions || (Actions = {}));
var Mutations;
(function (Mutations) {
    // Division for menu mapping project
    Mutations["SET_DIVISION_LOAD"] = "setDivisionWasFirstLoad";
    Mutations["SET_DIVISION_LIST"] = "setDivisionList";
    Mutations["SET_DIVISION_HANDLE_PAGE"] = "setDivisionHandlePage";
    Mutations["SET_DIVISION_PAGE"] = "setDivisionPage";
    Mutations["SET_DIVISION_LOAD_PAGE"] = "setDivisionLoadPage";
    Mutations["SET_DIVISION_LOADING"] = "setDivisionLoading";
    Mutations["SET_DIVISION_STATUS"] = "setDivisionStatus";
    Mutations["SET_SELECTED_DIVISION_NAME"] = "setSelectedDivisionName";
    Mutations["SET_DROPDOWNLIST_DIVISION_CODE"] = "setDropdownlistDivisionCode";
    Mutations["SET_DROPDOWNLIST_DIVISION_NAME"] = "setDropdownlistDivisionName";
    Mutations["SET_DIVISION_SIZE"] = "setDivisionSize";
    Mutations["SET_DIVISION_HANDLE_SIZE"] = "setDivisionHandleSize";
    Mutations["SET_DIVISION_PAGE_FILTER"] = "setDivisionPageFilter";
    Mutations["SET_DIVISION_WAS_LOAD_QUICK_FILTER"] = "setDivisionWasLoadQuickFilter";
    Mutations["SET_DIVISION_DESC"] = "setDivisionSelectedDesc";
    Mutations["SET_DIVISION_SEARCH_BY"] = "setDivisionSelectedSearchBy";
})(Mutations || (Mutations = {}));
export { Actions, Mutations };
